import React from 'react';
import { LineChart } from '@profitfy/pakkun-icons';
import { useTheme } from 'styled-components/macro';

import { ICampaignProps } from '@domain/interfaces/dashboard/AdsManager/Table/Campaign/ICampaign';
import { INetProfit } from '@domain/interfaces/dashboard/AdsManager/AdSenseCampaigns/IAdSenseCampaign';

import { useStoreConfig } from '@helpers/hooks/useStoreConfig';
import { useConfig } from '@helpers/hooks/useConfig';

import { numberFormatter } from '@helpers/masks';

import BlurredContent from './BlurredContent';

import * as S from './styles';

const Profit: React.FC<ICampaignProps> = ({ data, forecastData, rowData }) => {
  const profitData: INetProfit = data;

  const { store } = useStoreConfig();
  const { isDemoEnvironment } = useConfig();
  const theme = useTheme();

  const getIconColor = React.useCallback(
    amount => {
      if (amount > 0) return theme.colors.success.default;

      if (amount < 0) return theme.colors.danger.default;

      return theme.colors.gray[1];
    },
    [theme],
  );

  const forecastAmount = forecastData?.amount || 0;

  const isContentBlurred =
    (!store.is_utm_onboarding_finished || !rowData.has_at_least_one_ads_with_utm_synchronized) &&
    !isDemoEnvironment &&
    !rowData.has_all_ads_with_utm_synchronized;

  return (
    <S.Wrapper>
      {isContentBlurred ? (
        <BlurredContent />
      ) : (
        <>
          <S.ProfitAmount amount={profitData.amount}>
            {`R$ ${numberFormatter(profitData.amount, 2)}`}
          </S.ProfitAmount>

          {Boolean(forecastData) && (
            <S.ForecastAmount amount={forecastAmount}>
              <LineChart outline size={12} color={getIconColor(forecastAmount)} />
              {numberFormatter(forecastAmount, 2)}
            </S.ForecastAmount>
          )}
        </>
      )}
    </S.Wrapper>
  );
};

export default Profit;
